import edap from '@homeaway/edap-wrapper';

// EDAP EVENTS
export const ONEKEY_EARN_PRESENTED = 'onekey_earnmessage.presented';

// ACTION LOCATIONS
export const LOYALTY_WRAPPER_LOCATION = 'stay_ui_loyalty_wrapper';

export const triggerLoyaltyEarnPresented = (eventName, properties) => {
    edap().push({
        name: eventName,
        data: properties,
    });
};
